import axios from "axios";
import $store from "../store";
import toLogin from "@libs/login";
import { oAuth } from "@libs/wechat";
import { VUE_APP_API_URL } from "@utils/index";

const service = axios.create({
  baseURL: VUE_APP_API_URL + "/", // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config["baseURL"] += config["model"] || "Wechat";

    config["url"].indexOf("http") >= 0
      ? (config["baseURL"] = config["url"])
      : (config["baseURL"] += config["model"] || "Wechat");
    if ($store.state.app.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = $store.state.app.token;
    }
    // console.log('config:',config)
    // config.withCredentials = true;
    // config.method = 'post';
    // config.headers['Content-type'] = 'application/x-www-form-urlencoded'
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */
  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response["status"] && response["status"] == "201") {
      return response.data;
    }
    const res = response.data.result;
    // console.log(response)
    // console.log('response', response.data.result.data[0]['is_shop'])
    // if the custom code is not 20000, it is judged as an error.
    if (res.token) {
      setToken(res.token);
    }
    if (res.status !== 1) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.status === -1) {
        // to re-login
        if ($store.state.app.userInfo["id"]) {
          $store.commit("LOGOUT");
          oAuth();
        } else {
          toLogin();
        }
        return Promise.reject(res.msg);
      } else if (res.status === -2) {
        toLogin("", location.pathname + location.search, true);
        console.log("removeToken：", res.status);
        return Promise.reject(res.msg);
      }
      return Promise.reject(res.msg || "error");
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    // Message({
    //     message: error.msg,
    //     type: 'error',
    //     duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);

function setToken(token) {
  $store.commit("LOGIN", token);
}

export default service;
